export default __webpack_public_path__ + "5cb037e510dc7b93730ad4a1007fdfb5.png";